import { cn } from 'src/lib/utils';
import SideBar from './SideBar';
// import Header from './Header';
import { useState, useEffect } from 'react';

const PageLayout = ({ children }) => {
    const [isMobileView, setIsMobileView] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    // Handle responsive sidebar
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        
        // Set initial value
        handleResize();
        
        // Add event listener
        window.addEventListener('resize', handleResize);
        
        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="flex flex-col md:flex-row">
            {/* Sidebar - hidden on mobile by default, shown when toggled */}
            <div  className={cn('translate-x-0 z-50',{
                    'fixed transition-transform duration-300 ease-in-out transform': isMobileView,
                    '-translate-x-full': isMobileView && !sidebarOpen,
                })}
                            >
                <SideBar />
            </div>
            
            {/* Mobile menu toggle button */}
            {isMobileView && (
                <button 
                    onClick={toggleSidebar}
                    className="fixed z-50 top-4 left-4 p-2 rounded-md bg-vekin text-white shadow-lg"
                    aria-label="Toggle menu"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={sidebarOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                    </svg>
                </button>
            )}
            
            {/* Main content area */}
            <div className="w-full h-screen overflow-hidden">
                <div className="w-full h-full overflow-x-auto overflow-y-auto bg-vekin-green-50 scroll-smooth">
                    <div 
                    // className="p-4 md:p-6"
                    >
                        {/* <Header /> */}
                        {children}
                    </div>
                </div>
            </div>
            
            {/* Overlay for mobile when sidebar is open */}
            {isMobileView && sidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={toggleSidebar}
                    aria-hidden="true"
                />
            )}
        </div>
    );
}

export default PageLayout;
